/** @module Enums */ /** typedoc */

export enum PlanFrequencyEnum {
    Monthly = 'Monthly',
    Yearly = 'Yearly'
}
